<template>
  <div class="group-comment-container">
    <LoadingBox v-if="isLoading" />

    <div class="comment-container">
      <picture class="user-avatar embed-responsive embed-responsive-1by1">
        <img class="embed-responsive-item" :src="comment.user.avatar" />
      </picture>

      <div class="comment-body">
        <div class="comment-body-content">
          <div class="d-flex justify-content-between">
            <div class="comment-details">
              <span class="user-name">{{ comment.user.name }}</span>
              <div class="publish-date">{{ commentDate }}</div>
            </div>
            <TextButton v-if="comment.user.id == user.id" @click="deleteComment">
              <span class="delete-comment-text">excluir</span>
            </TextButton>
          </div>

          <div class="comment-content">{{ comment.comment }}</div>

          <div v-if="hasUserSubscriptionAccess" class="comment-options">
            <TextButton
              class="comment-option"
              @click="openReplyForm"
            >> responder</TextButton>           
          </div>
        </div>

        <div
          v-if="isReplyFormVisible || comment.replies.length"
          class="replies-container"
        >
          <GroupCommentForm
            ref="commentForm"
            v-if="isReplyFormVisible"
            :course-id="comment.course_id"
            :course-group-id="comment.id"
            class="comment-reply"
          />

          <div v-if="comment.replies.length">
            <GroupCommentReply
              v-for="commentReply in comment.replies"
              :key="commentReply.id"
              :comment="commentReply"
              class="comment-reply"
            />

            <TextButton
              v-if="hasCourseGroupRepliesMorePages(comment.id)"
              class="text-center"
              @click="
                fetchCourseGroupReplies({
                  courseId: comment.course_id,
                  courseGroupId: comment.id,
                })
              "
              >mais respostas</TextButton
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "moment/locale/pt";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import GroupCommentReply from "./GroupCommentReply";
import GroupCommentForm from "./GroupCommentForm";
import TextButton from "@/components/buttons/TextButton";
import LoadingBox from "@/components/layout/LoadingBox";

export default {
  components: {
    GroupCommentReply,
    GroupCommentForm,
    TextButton,
    LoadingBox,
  },

  props: {
    comment: { type: Object, default: () => ({}) },
  },

  data: () => ({
    isReplyFormVisible: false,
    isLoading: false,
  }),

  computed: {
    ...mapGetters("courseGroup", ["hasCourseGroupRepliesMorePages"]),

    ...mapGetters("course", ["hasCourseAccess"]),

    ...mapGetters("user", ["user", 'hasUserSubscriptionAccess']),

    commentDate() {
      return moment(this.comment.created_at).fromNow();
    },
  },

  methods: {
    ...mapActions("courseGroup", ["fetchCourseGroupReplies", "deleteCourseGroup"]),

    openReplyForm() {
      this.isReplyFormVisible = true;

      this.$nextTick(() => this.$refs.commentForm.$refs.textarea.focus());
    },

    async deleteComment() {
      if (!confirm("Tem certeza que deseja deletar seu comentário?")) {
        return null;
      }

      this.isLoading = true;

      await this.deleteCourseGroup({
        courseId: this.comment.course_id,
        courseGroupId: this.comment.id,
      });

      this.isLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.group-comment-container {
  position: relative;
}

.comment-container {
  display: flex;

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    flex-shrink: 0;
    margin-right: 10px;
  }

  .comment-body {
    width: 100%;

    .comment-body-content {
      padding: 12px;
      border-radius: 10px;
      border: 1px solid rgba(#000, 0.1);
      box-shadow: 1px 1px 6px rgba(#000, 0.1);

      .delete-comment-text {
        display: none;
        color: rgba(#000, 0.3);
        font-weight: 500;
        font-size: 13px;
      }

      &:hover .delete-comment-text {
        display: block;
      }

      .comment-details {
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        .publish-date {
          font-size: 13px;
          color: rgba(#000, 0.6);

          &:before {
            content: "•";
            margin: 0 6px;
            color: rgba(#000, 0.6);
          }
        }

        .user-name {
          font-family: "Poppins";
          font-size: 15px;
          font-weight: 600;
        }
      }

      .comment-content {
        font-family: "Lato";
        font-size: 15px;
      }

      .comment-options {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
      }
    }

    .replies-container {
      margin-top: 20px;
    }
  }
}

.replies-container .comment-reply:not(:last-child),
.comment-reply-divisor {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(#000, 0.15);
}
</style>
